import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest, select } from 'redux-saga/effects'
import { UserModel } from '../models/UserModel'
import { getUserByToken } from "./AuthCRUD";

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  LoginUsingToken: '[Login Using Token] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
  SetFilterPortFolioData: '[Set Filter PortFolio Data]',
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
  loginUsingToken: undefined,
  data: undefined,
  portfolioData: undefined,
}

export interface IAuthState {
  user?: UserModel
  accessToken?: string
  loginUsingToken?: Boolean
  data?: any
  portfolioData?: any
}

export const reducer = persistReducer(
  { storage, key: 'user', whitelist: ['user', 'loginUsingToken', 'accessToken'] },
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const accessToken = action.payload?.accessToken
        return { accessToken, loginUsingToken: false, user: undefined }
      }

      case actionTypes.LoginUsingToken: {
        const accessToken = action.payload?.accessToken
        return { accessToken, loginUsingToken: true, user: undefined }
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return { ...state, user }
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return { ...state, user }
      }


      // Filter Reducer for PortFolio
      case actionTypes.SetFilterPortFolioData: {
        const portfolioData = action.payload?.portfolioData
        return { ...state, portfolioData }
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: string) => ({ type: actionTypes.Login, payload: { accessToken } }),
  loginUsingToken: (accessToken: string) => ({ type: actionTypes.LoginUsingToken, payload: { accessToken } }),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: { accessToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: UserModel) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user: UserModel) => ({ type: actionTypes.SetUser, payload: { user } }),



  SetFilterPortFolioData: (portfolioData: any) => ({ type: actionTypes.SetFilterPortFolioData, payload: { portfolioData } }),

}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  // Login using Token
  yield takeLatest(actionTypes.LoginUsingToken, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const getToken = (state: any) => state.auth.accessToken;
    let token = yield select(getToken)
    const { data: user } = yield getUserByToken(token)
    yield put(actions.fulfillUser(user))
  })

}

